import React, { useCallback, useMemo } from "react";

import { MDBDataTable } from "mdbreact";
import { Card, CardBody } from "reactstrap";

//Rows and col's data
import dataTable from "./data/table-data";

import "./ConversationList.scss";

//i18n
import { withTranslation } from "react-i18next";

const Index = ({
  t,
  qtdDefault,
  conversationsCheckedArray,
  setConversationsCheckedArray,
  orderBy,
  handleSort,
  ...props
}) => {
  const checkbox = useCallback(() => {
    return (
      <div key={1} className="custom-control custom-checkbox">
        <input
          type="checkbox"
          className="custom-control-input"
          checked={conversationsCheckedArray.all}
          readOnly
        />
        <label
          className="custom-control-label pointer"
          onClick={() => {
            if (props.tableData) {
              let list = Array(conversationsCheckedArray.list.length).fill(
                false
              );
              if (!conversationsCheckedArray.all) {
                list = [
                  ...props.tableData.map((e) => ({
                    ...e,
                    status: e.statusName,
                  })),
                ];
              }
              setConversationsCheckedArray((prev) => ({
                ...prev,
                all: !prev.all,
                list,
              }));
            }
          }}
        ></label>
      </div>
    );
  }, [
    props.tableData,
    conversationsCheckedArray,
    setConversationsCheckedArray,
  ]);

  const orderByComponent = useCallback(
    (name, label = "") => {
      return (
        <div
          key={name?.length}
          className={`d-flex flex-nowrap justify-content-center align-items-center cursor-pointer${
            orderBy.name === "status" && name === "status" ? "-not" : ""
          }`}
          onClick={() => handleSort(name)}
        >
          <p className="m-0">{label}</p>
          {orderBy.name === name ? (
            <i
              className={`mdi mdi-chevron-${
                orderBy.order === -1 ? "down" : "up"
              } font-size-16`}
            />
          ) : (
            <i className={`mdi mdi-arrow-right font-size-14`} />
          )}
        </div>
      );
    },
    [orderBy, handleSort]
  );

  const indexElement = (name) => {
    const index = dataTable.columns.indexOf(
      dataTable.columns.find((element) => element.field === name)
    );

    return index;
  };

  const columns = useMemo(() => {
    let _columns = dataTable.columns.map((element) => ({
      ...element,
      label: t(element.label),
    }));

    let index = indexElement("status");
    _columns[index].label = [orderByComponent("status", _columns[index].label)];

    index = indexElement("created_at");
    _columns[index].label = [
      orderByComponent("created_at", _columns[index].label),
    ];

    index = indexElement("end_conversation_time");
    _columns[index].label = [
      orderByComponent("end_conversation_time", _columns[index].label),
    ];

    index = indexElement("last_msg_consumer");
    _columns[index].label = [
      orderByComponent("last_msg_consumer", _columns[index].label),
    ];

    index = indexElement("duration");
    _columns[index].label = [
      orderByComponent("duration", _columns[index].label),
    ];

    index = indexElement("consumer_name");
    _columns[index].label = [
      orderByComponent("consumer_name", _columns[index].label),
    ];

    const obj = {
      label: [checkbox()],
      field: "select",
    };

    return [obj, ..._columns];
  }, [orderByComponent, checkbox, t]);

  const renderTable = useCallback(() => {
    return (
      <>
        {props.loadingData && (
          <div className="loading-records">
            <span>{t("Loading...")}</span>
          </div>
        )}
        { props?.tableData?.length > 0 ? (
          <MDBDataTable
            entries={qtdDefault}
            id="mdb-data-table-conversation"
            className={`conversations-mdb-data-table ${props.loadingData ? "loading-records-view" : ""}`}
            responsive
            hover
            bordered
            sortable={false}
            searching={false}
            data={{
              columns,
              rows: props.tableData,
            }}
          />
        ) : (
          <>
            {!props.loadingData && (
                <div className="no-matching-records">
                  <span>{t("No matching records found")}</span>
                </div>
            )}
          </>
        )}
      </>
    );
  }, [columns, props.tableData, props.loadingData, qtdDefault, t]);

  return (
    <Card className="mb-0 w-100">
      <CardBody className="card-body-conversation pb-0 px-0 mb-0">
        {renderTable()}
      </CardBody>
    </Card>
  );
};

export default withTranslation()(React.memo(Index));
